import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [token, setToken]     = useState(localStorage.getItem('mg_token'));
  const [loading, setLoading] = useState(true);

  // Βάλε token στα headers κάθε request
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Verify token on load
  useEffect(() => {
    if (!token) { setLoading(false); return; }
    axios.get('/api/auth/me')
      .then(r => setUser(r.data))
      .catch(() => { logout(); })
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  function login(newToken, userData) {
    localStorage.setItem('mg_token', newToken);
    setToken(newToken);
    setUser(userData);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
  }

  function logout() {
    localStorage.removeItem('mg_token');
    setToken(null);
    setUser(null);
    delete axios.defaults.headers.common['Authorization'];
  }

  const isAdmin    = user?.role === 'admin';
  const isCashier  = user?.role === 'cashier';
  const isTech     = user?.role === 'technician';

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAdmin, isCashier, isTech, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }